import App from "./App";
import { convertReact2WebComponent } from "./convertReactToWebStyledComponent";

const JobRadRechnerApp = convertReact2WebComponent(App, {
  props: { apiUrl: "string", signUpUrl: "string", ctaUrl: "string", calculatorEnv: "string" },
  shadow: "open",
});

customElements.define("jobrad-rechner", JobRadRechnerApp);

export default JobRadRechnerApp;
